import { UrlObject } from 'url'
import { ParsedUrlQueryInput } from 'querystring'

export const isUrlObject = (value): value is UrlObject => {
  return (value as UrlObject).pathname !== undefined
}
export const isParsedUrlQueryInput = (value): value is ParsedUrlQueryInput => {
  return (value as ParsedUrlQueryInput).state !== undefined
}
